import React, { useEffect, useState } from 'react';
import { Button, Col, ConfigProvider, Form, Input, InputNumber, Modal, Row, TreeSelect, Typography, Select } from 'antd';
import locale from "antd/es/locale/es_ES";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { PostProjectesIdTasques } from "../../../dao/abp/PostProjectesIdTasques";
import { GetSprintsByProject } from "../../../dao/abp/GetSprintsByProject";

const { TextArea } = Input;

interface Props {
    element: any; // Changed to any to allow property access
    visible: boolean;
    id_projecte: string;
    data: [];
    tasks?: any[];
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const TascaModal: React.FC<Props> = (props: Props) => {
    const [form] = Form.useForm();
    const { Title } = Typography;
    const [sprints, setSprints] = useState<any[]>([]);

    useEffect(() => {
        if (props.visible && props.id_projecte) {
            loadSprints();
        }
    }, [props.visible, props.id_projecte]);

    useEffect(() => {
        if (props.visible && props.element) {
            form.resetFields();
            const initialValues = { 
                id: undefined, 
                id_tarea_padre: undefined,
                ...props.element 
            };
            if (initialValues.sprint !== undefined && initialValues.sprint !== null) {
                initialValues.sprint = String(initialValues.sprint);
            }
            form.setFieldsValue(initialValues);
        } else if (!props.visible) {
            form.resetFields();
        }
    }, [props.visible, props.element, form]);

    async function loadSprints() {
        const data = await GetSprintsByProject(props.id_projecte);
        setSprints(data || []);
    }

    async function handleSubmit() {
        try {
            const formData = await form.validateFields();
            await PostProjectesIdTasques(formData, props.id_projecte);
            props.onClose(true);
        } catch (error) {
            console.error("Validation Failed:", error);
        }
    }

    const handleCancel = () => {
        props.onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title={<Title level={4} style={{ margin: 0 }}>Editar Tasca</Title>}
                open={props.visible}
                onCancel={handleCancel}
                onOk={handleSubmit}
                width={600}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel·lar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleSubmit}
                        style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                    >
                        Guardar
                    </Button>,
                ]}
            >
                <Form
                    form={form}
                    initialValues={props.element}
                    onFinish={handleSubmit}
                    layout="vertical"
                    style={{ marginTop: 24 }}
                >
                    <Form.Item label="ID" name="id" hidden>
                        <Input />
                    </Form.Item>

                    <Form.Item label="Tasca Pare (Opcional)" name="id_tarea_padre">
                        <Select
                            allowClear
                            showSearch
                            placeholder="Selecciona una tasca pare si és una subtasca"
                            optionFilterProp="label"
                            options={props.tasks?.filter(t => t.id !== props.element?.id && (!t.id_tarea_padre)).map(t => ({
                                value: t.id,
                                label: `#${t.id} - ${t.descripcio?.substring(0, 80)}${t.descripcio && t.descripcio.length > 80 ? '...' : ''}`
                            }))}
                        />
                    </Form.Item>

                    <Form.Item label="Resultat d'Aprenentatge (RA)" name="ra"
                        rules={[{ required: true, message: 'Selecciona un RA' }]}>
                        <TreeSelect
                            treeData={props.data?.map((node: any) => ({
                                ...node,
                                disabled: !node.isLeaf,
                                children: node.children?.map((child: any) => ({
                                    ...child,
                                    disabled: !child.isLeaf,
                                })),
                            }))}
                            style={{ width: '100%' }}
                            placeholder="Selecciona Mòdul - RA"
                            treeCheckable={false}
                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                            treeDefaultExpandAll
                        />
                    </Form.Item>

                    <Form.Item label="Descripció de la Tasca" name="descripcio"
                        rules={[{ required: true, message: 'La descripció és obligatòria' }]}>
                        <TextArea rows={4} placeholder="Descripció detallada de la tasca" />
                    </Form.Item>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Sprint" name="sprint"
                                rules={[{ required: true, message: 'Selecciona un sprint' }]}>
                                <Select
                                    placeholder="Selecciona un sprint"
                                    options={sprints.map(s => ({
                                        value: String(s.numero),
                                        label: `${s.titol}${s.data_inici && s.data_final
                                            ? ` (${new Date(s.data_inici).toLocaleDateString()} - ${new Date(s.data_final).toLocaleDateString()})`
                                            : ''}`
                                    }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Pes (%)" name="pes"
                                rules={[{ required: true, message: 'Introdueix el pes' }]}>
                                <InputNumber
                                    min={0}
                                    max={100}
                                    style={{ width: '100%' }}
                                    formatter={value => `${value}%`}
                                    parser={(value: any) => value!.replace('%', '')}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default TascaModal;
